import React, { useState } from "react";
import { MdExpandMore } from "react-icons/md";
import styles from "./FAQ.module.css";

interface FAQItem {
  id: number;
  question: string;
  answer: string;
}

export default function FAQ() {
  const [openId, setOpenId] = useState<number | null>(1);

 
const faqs: FAQItem[] = [
  {
    id: 1,
    question: "What is Mechmiles and what services do you offer?",
    answer:
      "Mechmiles is an automotive solutions platform that brings tyres, batteries, accessories and vehicle-related services together in one place. We cater to two-wheelers, cars and commercial vehicles, offering services such as tyre replacement, puncture repair, wheel balancing, wheel alignment, nitrogen filling and more. Our aim is to make vehicle maintenance simpler, more accessible and convenient.",
  },
  {
    id: 2,
    question: "Where can I avail Mechmiles services?",
    answer:
      "Mechmiles has a growing network of service points across India. Our service locations include outlets at leading fuel stations operated by IOCL, BPCL, HPCL and Nayara Energies, along with other partner service centres. You can visit the Find Service Points section on our website to check the nearest available location.",
  },
  {
    id: 3,
    question: "Why should I choose Mechmiles over a regular tyre shop?",
    answer:
      "At Mechmiles, we focus on making tyre care and vehicle maintenance more organised and transparent. You get access to multiple tyre brands, a range of vehicle-related services, standardised service pricing and trained service partners. You can also explore available products and services online before visiting a service centre.",
  },
  {
    id: 4,
    question:
      "Can I avail Mechmiles services in a city other than my registered location?",
    answer:
      "Yes. You can explore service points in different cities, subject to availability. Simply log in to your Mechmiles account, select your preferred location and choose a service centre that suits your requirements.",
  },

  // 2. Tyres, Batteries and Products
  {
    id: 5,
    question: "How do I find the right tyre for my vehicle?",
    answer:
      "Finding the right tyre is simple. Select your vehicle category and enter your vehicle details or choose the relevant tyre size. Our website helps you explore compatible tyre options from available brands. If you're unsure about the correct size or specifications, our team can help you make an informed choice.",
  },
  {
    id: 6,
    question: "Which tyre brands are available on Mechmiles?",
    answer:
      "We offer tyres from leading brands, including Apollo, Bridgestone, CEAT, MRF, JK Tyre, TVS Eurogrip, Yokohama and other available brands. Product availability may vary depending on the vehicle category, tyre size and location.",
  },
  {
    id: 7,
    question:
      "Do you sell batteries and automotive accessories apart from tyres?",
    answer:
      "Yes. Mechmiles offers batteries and a range of automotive accessories in addition to tyres. You can browse the available products on our website and check their compatibility with your vehicle before placing an order.",
  },
  {
    id: 8,
    question:
      "Are the tyres and batteries sold on Mechmiles genuine?",
    answer:
      "We aim to provide genuine products sourced through authorised and reliable supply channels. Products are offered with the applicable manufacturer warranty, wherever provided. You can contact our team if you need assistance with product specifications or warranty-related information.",
  },

  // 3. Booking and Vehicle Services
  {
    id: 9,
    question: "How can I book a tyre-related service with Mechmiles?",
    answer:
      "Booking a service is straightforward:\n\n1. Visit the Mechmiles website or download our mobile application.\n2. Select the service you require.\n3. Choose a suitable service point and available appointment slot.\n4. Review your booking details and complete the payment process as displayed.\n\nOnce your booking request is submitted, you can follow the instructions provided for your appointment.",
  },
  {
    id: 10,
    question:
      "What types of tyre-related services can I book through Mechmiles?",
    answer:
      "You can explore a range of tyre care and maintenance services, including:\n\n• Tubeless tyre puncture repair.\n• Tube-type tyre puncture repair.\n• Tyre fitting and replacement.\n• Wheel balancing.\n• Wheel alignment.\n• Tyre rotation.\n• Nitrogen filling.\n\nThe availability of individual services may differ from one service centre to another.",
  },
  {
    id: 11,
    question:
      "How long does it take to complete a tyre-related service?",
    answer:
      "The time required depends on the service and your vehicle. As a general estimate, many routine services take between 10 and 30 minutes. More extensive work, such as replacing multiple tyres or carrying out additional checks, may take longer. Your selected service centre can provide a better estimate based on the work required.",
  },
  {
    id: 12,
    question: "Can I cancel my service booking? Will I be charged?",
    answer:
      "We understand that plans can change. As per our current booking FAQ, there is no cancellation charge for cancelling a service booking. We do request that you inform us as early as possible so the service centre can plan accordingly.\n\nFor any refund associated with an online payment, the applicable refund terms will apply.",
  },
  {
    id: 13,
    question:
      "What if the service I receive does not meet my expectations?",
    answer:
      "Your feedback matters to us. If you are not satisfied with a product or service, please contact our customer support team and share your booking details along with the issue you experienced. We will review your concern, coordinate with the concerned service partner and work towards an appropriate resolution.",
  },

  // 4. Payments, Returns and Warranty
  {
    id: 14,
    question: "What payment options are available on Mechmiles?",
    answer:
      "Mechmiles provides an online payment option through its booking process. The payment methods available to you will be displayed at checkout. Please review the final order amount and payment details before confirming your transaction.",
  },
  {
    id: 15,
    question:
      "What is the return and refund policy for products purchased from Mechmiles?",
    answer:
      "Eligible tyres and batteries can be returned within 30 days of delivery, provided they are unused, undamaged and in their original packaging.\n\nProducts that have been installed or used, damaged due to misuse or accidents, or purchased as customised or promotional final-sale items are generally not eligible for return.\n\nIf you receive a defective, damaged or incorrect product, please contact our customer support team within 7 days of delivery. Our team will guide you through the applicable return or refund process.\n\nFor complete details, please refer to our Return and Refund Policy on the website.",
  },
  {
    id: 16,
    question:
      "Why should you buy tyres and batteries from mechmiles.com?",
    answer:
      "Mechmiles is India's leading doorstep tyre and battery fitment service — we bring the tyre shop and battery shop to you instead of the other way around. Our well-equipped mobile vans and expert technicians handle fitment, wheel balancing, and installation at your home, office, or any location you choose.\n\nWe stock the widest selection of tyres and batteries from top domestic and international brands (CEAT, Apollo, Bridgestone, Yokohama, Amaron, Exide and more), offer transparent upfront pricing with no hidden charges, and only sell genuine branded products backed by manufacturer warranty. Over 75,000 customers trust us with a 4.9-star rating.",
  },
  {
    id: 17,
    question:
      "When will my order for tyres, batteries reach my location?",
    answer:
      "Congratulations on booking a world-class doorstep fitment experience with Mechmiles! We have state-of-the-art tyre and battery changing equipment in our Mechmiles doorstep fitment vans.\n\nOrders placed before 3 PM will be fulfilled the same day*, and orders placed after 3 PM will be fulfilled the next working day*.\n\nWe currently provide doorstep fitment services at Hyderabad, Secunderabad, Bengaluru, Pune, Pimpri-Chinchwad, Mumbai, Thane, Vashi, Navi Mumbai, Gurugram, Faridabad, Ghaziabad, Noida and Delhi-NCT.\n\n*The order fulfillment is subject to availability of the products in our warehouse. Our team will call you to fix an appointment for changing tyres at your location. For cities other than those mentioned above, our experts will inform you about the time of home delivery (fitment is not included here) and additional shipping charges, if any.",
  },
  {
    id: 18,
    question:
      "What are the Payment options, can I pay on delivery or through EMIs for tyres?",
    answer:
      "You can pay online at the time of placing your order, or choose Payment on Delivery — we accept cash, debit card, credit card, net banking, and mobile wallets.\n\nEMI availability depends on your bank and card issuer; if EMI is offered on your card, it will show up as a payment option at checkout.",
  },
  {
    id: 19,
    question:
      "How long will it take to change the tyres or battery once your experts reach my location?",
    answer:
      "Our experienced technicians ensure a smooth and efficient installation process — typically 30-45 minutes per vehicle for tyre replacement, battery change, or wheel balancing, depending on the vehicle type and service required.",
  },
  {
    id: 20,
    question:
      "Will I get a warranty for tyres, batteries that I buy on mechmiles.com?",
    answer:
      "Yes. All products sold on mechmiles.com are covered by a warranty policy — any claims on the product are processed as per the terms and conditions of the manufacturer's warranty. If a product is sold without a manufacturer's warranty (because none is provided by the manufacturer), we'll inform you before purchase.",
  },
  {
    id: 21,
    question: "Tyre shop near me?",
    answer:
      "You don't need to find one — Mechmiles brings the tyre shop to you! We offer doorstep tyre and battery fitment across Delhi-NCT, Bengaluru, Pune, Mumbai, Thane, Chennai, Navi Mumbai and Hyderabad, and home delivery in most other Indian cities.",
  },
];


  const handleToggle = (id: number) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section className={styles.faqSection}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>Frequently asked questions</h2>
        <div className={styles.faqList}>
          {faqs.map((faq) => {
            const isOpen = openId === faq.id;
            return (
              <div key={faq.id} className={styles.faqCard}>
                <button
                  onClick={() => handleToggle(faq.id)}
                  className={styles.faqQuestionBtn}
                  aria-expanded={isOpen}
                >
                  <span className={styles.questionText}>{faq.question}</span>
                  <span
                    className={`${styles.chevronIcon} ${isOpen ? styles.chevronRotated : ""}`}
                  >
                    <MdExpandMore size={24} />
                  </span>
                </button>
                <div
                  className={`${styles.answerWrapper} ${isOpen ? styles.open : ""}`}
                >
                  <div className={styles.answerText}>{faq.answer}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
